<div class="modal-header">
  <h4 class="modal-title">
    {{ title }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body administratorModal">

  <!-- Render progresivo: mientras llega el registro se pinta la silueta de las
       filas que van a existir, no un overlay ni un modal en blanco. -->
  @if (loading) {

    <div class="container-fluid placeholder-glow" aria-hidden="true">
      <div class="row">
        @for (key of visibleKeys; track key) {
          <div class="col-12 mt-2 mb-4">
            <div class="row align-items-center">
              <div class="col-8">
                <span class="placeholder col-9 rounded"></span>
              </div>
              <div class="col-4 text-end">
                <span class="placeholder administratorModal__switchPlaceholder rounded-pill"></span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <span class="visually-hidden" role="status">Cargando preferencias</span>

  } @else if (loadFailed) {

    <div class="administratorModal__state text-center">
      <i class="material-icons administratorModal__stateIcon" aria-hidden="true">cloud_off</i>
      <p class="administratorModal__stateText mb-3">No se pudieron cargar tus preferencias.</p>
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="loadData()">
        Reintentar
      </button>
    </div>

  } @else {

    <form
      id="formAdministrator"
      [formGroup]="formAdministrator"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          @for (key of visibleKeys; track key) {
            @if (dataForm[key].type === 'switch') {
              <div class="col-12 mt-2 mb-4">
                <div class="row">
                  <div class="col-8">
                    <label class="administratorModal__label mb-0" [attr.for]="key">
                      {{ dataForm[key].label }}
                    </label>
                  </div>
                  <div class="col-4 text-end">
                    <p-inputSwitch
                      inputId="{{ key }}"
                      formControlName="{{ key }}">
                    </p-inputSwitch>

                    <!-- El estado binario se dice con palabras, no solo con el
                         color del switch. Apagado en gris, nunca en rojo. -->
                    <div
                      class="administratorModal__switchState"
                      [class.administratorModal__switchStateOff]="!f[key].value">
                      {{ f[key].value ? 'Activado' : 'Desactivado' }}
                    </div>
                  </div>
                </div>
              </div>
            }
          }

        </div>
      </div>
    </form>

  }

</div>
<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>

  <!-- Si no hay nada cargado no hay nada que guardar: el botón no se deshabilita,
       simplemente no existe todavía. -->
  @if (!loadFailed) {
    <div class="col-12">
      <button
        type="submit"
        form="formAdministrator"
        class="btn btn-primary w-100">
        Actualizar
      </button>
    </div>
  }
</div>
